import React, { CSSProperties, ReactNode } from "react";

type SubTextProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

export const SubText = (props: SubTextProps) => {
  const { children, className, style } = props;

  return (
    <p className={className} style={{ margin: 0, paddingTop: 10, ...style }}>
      {children}
    </p>
  );
};
